'use client';

import { FormattedMessage, useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';
import { ButtonLink } from '@packages/shared/src/ui/Button/Button';
import { Link } from '@packages/modules/src/Link/Link';

export type OrderDetailsButtonProps = {
  /** Order number to link to */
  orderNo: string;
};

/**
 * OrderDetailsButton component renders a button/link to view order details
 */
export const OrderDetailsButton = ({ orderNo }: OrderDetailsButtonProps) => {
  const { locale } = useIntl();
  const {
    order: {
      paths: { myAccountOrders },
    },
  } = useConfig();

  return (
    <ButtonLink
      LinkComponent={Link}
      href={`${getLocalizedPath(myAccountOrders, locale)}/${orderNo}`}
      className="w-full md:w-auto"
    >
      <FormattedMessage id="OrderDetailsButton.Label" defaultMessage="Details anzeigen" />
    </ButtonLink>
  );
};
